<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slproductlog}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:slproductlog:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:slproductlog:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border  style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <el-table-column prop="id" label="编号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="日志类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="content" label="操作内容" header-align="center" align="center">
          <template slot-scope="scope">
              <el-button  v-if="scope.row.content !=='string' && scope.row.content !==''" type="text" style="text-decoration: underline;" @click="handleReturnMsg(scope.row.content)">内容</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:slproductlog:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:slproductlog:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
    <el-dialog
        title="返回信息"
        :visible.sync="dialogVisible"
        width="30%" >
   
      <span v-html="returnedMessagesVal"></span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './slproductlog-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/slproductlog/page',
        getDataListIsPage: true,
        exportURL: '/sys/slproductlog/export',
        deleteURL: '/sys/slproductlog',
        deleteIsBatch: true
      },
      dialogVisible: false,
      returnedMessagesVal: '',
      dataForm: {
        id: ''
      }
    }
  },
  methods: {
    handleReturnMsg(returnMsg){
        // let arr = ''
        // JSON.parse(returnMsg).provinces.forEach(item => {
        //   if(item.istrue){
        //       arr += `<br/>${item.name}: `
        //   }
        //   item.cities.forEach(item1 => {
        //     if(item1.istrue){
        //       arr += `${item1.name} `
        //     }
        //   })
          
        // })
        // console.log(...arr)
        this.returnedMessagesVal = returnMsg
    
      this.$nextTick(() =>{
        this.dialogVisible = true;
       
      })
    },
  },
  components: {
    AddOrUpdate
  }
}
</script>
